import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CollectionService } from 'src/app/services/collection.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';

@Component({
  selector: 'app-shop-collection',
  templateUrl: './shop-collection.component.html',
  styleUrls: ['./shop-collection.component.scss']
})
export class ShopCollectionComponent implements OnInit {

  collectionFilterForm: any;
  order: {};
  limit: number;
  page: number;
  count: number;
  maxPage: number;
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'ShopCollections.id': 'DESC' };
  filtered = {};
  groups: any;
  collections: any[] = [];
  
  constructor(
    private authStatusService: AuthStatusService,
    private route: ActivatedRoute,
    private router: Router,
    private collectionService: CollectionService,
    private commanUsesService: CommanUsesService,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() { 
    try {
      this.manageCollectionFilterForm();
      await this.filter();
    } catch (error) {
      console.log("error", error)
      this.commanUsesService.showSnackBar("SOMETHING_WENT_WRONG");
    }
  }
  manageCollectionFilterForm(){
    this.collectionFilterForm = new FormGroup({
      'ShopCollections.id': new FormControl(''),
      'ShopCollections.collectionName': new FormControl(''),
      'ShopCollections.handle': new FormControl(''),
      'ShopCollections.bodyHtml': new FormControl(''),
      'ProductCategory.categoryName': new FormControl(''),
      'Provinces.province': new FormControl(''),
      'Provinces.provinceCode': new FormControl(''),
    })
  }

  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.collectionFilterForm);
    this.filtered = {};
    if (filterForm['ShopCollections.id'])
      this.filtered['ShopCollections.id'] = filterForm['ShopCollections.id'];  
    if (filterForm['ShopCollections.collectionName'])
      this.filtered['ShopCollections.collectionName'] = { operator: 'like', values: [`%${filterForm['ShopCollections.collectionName']}%`]};
    if (filterForm['ShopCollections.handle'])
      this.filtered['ShopCollections.handle'] = { operator: 'like', values: [`%${filterForm['ShopCollections.handle']}%`]};
    if (filterForm['ShopCollections.bodyHtml'])
      this.filtered['ShopCollections.bodyHtml'] = { operator: 'like', values: [`%${filterForm['ShopCollections.bodyHtml']}%`]};
    if (filterForm['Provinces.province'])
      this.filtered['Provinces.province'] = { operator: 'like', values: [`%${filterForm['Provinces.province']}%`]};
    if (filterForm['ProductCategory.categoryName'])
      this.filtered['ProductCategory.categoryName'] = { operator: 'like', values: [`%${filterForm['ProductCategory.categoryName']}%`]};
    if (filterForm['Provinces.provinceCode'])
      this.filtered['Provinces.provinceCode'] = { operator: 'like', values: [`%${filterForm['Provinces.provinceCode']}%`]};
    await this.loadCollections();
  }

  async loadCollections(limit?: number, page?: number, order?: {}) {
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    let collections = await this.collectionService.getAllShopCollections(this.page, this.limit, this.order, this.filtered);
    this.collections = collections.collections;
    this.count = collections.count;
    this.maxPage = Math.ceil(this.count / this.limit);
  }
  
  async resetFliter() {
    this.manageCollectionFilterForm();
    await this.filter();
  }

  async deleteShopCollection(id: number) {
    try {
      if(!confirm(`Sei sicuro? La raccolta verrà eliminata.`))
        return false;

      let result = await this.collectionService.deleteCollection(id);
      if(result.success) {
        this.commanUsesService.showSnackBar('COLLECTION_REMOVED_SUCCESFULLY');
        await this.loadCollections();
      } else {
        this.commanUsesService.showSnackBar('SOMETHING_WENT_WRONG');
      }
    } catch (error) {
      const errorMessage = error?.message || 'An unexpected error occurred. Please try again.';
      this.commanUsesService.showSnackBar(errorMessage);
    }
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  public async navigateOrder(attribute: string | string[]) {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.loadCollections();
    });
  }

  async navigate(event) {
    await this.loadCollections(event.limit, event.page, this.order);
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

}
